import { Component, Input, OnInit } from '@angular/core';
import { DateTimeHelpers } from '@global/infrastructure/helpers/date-time-helpers';

@Component({
  selector: 'app-section-heading',
  templateUrl: './section-heading.component.html'
})
export class SectionHeadingComponent implements OnInit {
  @Input() mainTitle: string;
  @Input() subTitle: string;
  @Input() titleIcon: string;
  @Input() policyId: string;
  @Input() isShowPolicyNumber: boolean;
  @Input() isNotification: boolean;
  @Input() policyChangeDate: Date;

  policyChangeDateString: string;

  ngOnInit(): void {
    this.policyChangeDateString = DateTimeHelpers.toWordFormat(this.policyChangeDate);
  }
}
